var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSmartCatalogMagicWand(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.285 0a.572.572 0 01.571.571v.572h.572a.571.571 0 110 1.142h-.572v.572a.572.572 0 01-1.143 0v-.572h-.571a.571.571 0 010-1.142h.571V.57A.571.571 0 0114.285 0zM2.857 2.286a.571.571 0 01.572.57v.572H4a.571.571 0 010 1.143h-.571v.571a.571.571 0 11-1.143 0v-.571h-.572a.571.571 0 110-1.143h.572v-.571a.571.571 0 01.571-.571zM13.142 12.57a.571.571 0 000-1.143h-.571v-.571a.572.572 0 00-1.143 0v.571h-.572a.571.571 0 000 1.143h.572v.572a.571.571 0 101.143 0v-.572h.571zM8.834 4.072a2.188 2.188 0 013.093 3.094L3.734 15.36A2.188 2.188 0 01.64 12.265l8.194-8.193zm-.549 2.164l-6.837 6.837a1.045 1.045 0 101.478 1.477l6.837-6.836-1.478-1.478zm2.286.67l.548-.549a1.046 1.046 0 10-1.477-1.476l-.549.548 1.478 1.477z",
    fill: "currentColor"
  })));
}

export default SvgSmartCatalogMagicWand;